import './App.css';

const appStoreUrl = 'https://apps.apple.com/app/intervioai';
const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.engineercodewala.intervioai';

const iconPaths = {
  mic: 'M12 2a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Zm7 9a7 7 0 0 1-14 0M12 18v4M8 22h8',
  target: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0-5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-3a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
  chart: 'M4 19V5M4 19h16M8 16v-5M12 16V8M16 16v-8M20 16v-3',
  layers: 'm12 3 8 4-8 4-8-4 8-4Zm-8 9 8 4 8-4M4 17l8 4 8-4',
  users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm13 10v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',
  message: 'M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8Z',
  globe: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20ZM2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20',
  shield: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Zm-3-10 2 2 4-5',
  briefcase: 'M10 6V5a2 2 0 0 1 2-2h0a2 2 0 0 1 2 2v1M3 8h18v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8Zm0 5h18',
  arrow: 'M5 12h14M13 5l7 7-7 7',
  check: 'M20 6 9 17l-5-5',
  apple: 'M16.4 13.2c0-2.5 2.1-3.7 2.2-3.8-1.2-1.7-3-1.9-3.6-1.9-1.5-.2-2.9.9-3.6.9-.8 0-2-.9-3.3-.9-1.7 0-3.3 1-4.2 2.6-1.8 3.1-.5 7.7 1.3 10.2.9 1.2 1.9 2.6 3.2 2.5 1.3-.1 1.8-.8 3.3-.8 1.6 0 2 .8 3.4.8 1.4 0 2.3-1.2 3.1-2.5 1-1.4 1.4-2.8 1.4-2.9 0 0-2.8-1.1-2.8-4.2ZM14.1 5.9c.7-.8 1.1-1.9 1-3-.9.1-2 .6-2.7 1.4-.6.7-1.1 1.8-1 2.8 1.1.1 2-.5 2.7-1.2Z',
  android: 'M7.2 8.4h9.6a2.8 2.8 0 0 1 2.8 2.8v5.6a2.8 2.8 0 0 1-2.8 2.8H7.2a2.8 2.8 0 0 1-2.8-2.8v-5.6a2.8 2.8 0 0 1 2.8-2.8Zm-.8-2.8 1.9 2.8M17.6 5.6l-1.9 2.8M8.4 12.2h.1M15.5 12.2h.1M8 19.6V22M16 19.6V22M2 12v4M22 12v4',
  play: 'M5 3.6v16.8c0 .8.8 1.2 1.4.8l9.9-8.4c.5-.4.5-1.2 0-1.6L6.4 2.8C5.8 2.4 5 2.8 5 3.6Zm11.9 8.4 2.4-2c.6-.5.5-1.4-.2-1.8L15.7 6l-3.1 2.7 4.3 3.3Zm0 0-4.3 3.3 3.1 2.7 3.4-2.2c.7-.4.8-1.3.2-1.8l-2.4-2Z',
};

const rounds = ['HR', 'Technical', 'Technical deep dive', 'Managerial', 'Final HR', 'English Helper'];

const signals = [
  ['5', 'interview round types'],
  ['30 min', 'technical practice sessions'],
  ['AI', 'feedback after every attempt'],
  ['Audio', 'recordings you can replay'],
];

const workflow = [
  ['01', 'target', 'Choose', 'Pick the exact round, role, language, duration, difficulty, and experience level.'],
  ['02', 'mic', 'Speak', 'Answer the AI interviewer out loud so practice feels closer to a real conversation.'],
  ['03', 'chart', 'Improve', 'Review scores, strengths, gaps, and next steps before your next attempt.'],
];

const features = [
  {
    icon: 'mic',
    title: 'Voice mock interviews',
    body: 'Train delivery, clarity, pacing, and confidence with spoken AI-led rounds.',
  },
  {
    icon: 'target',
    title: 'Role-aware questions',
    body: 'Questions adapt around your target role, skills, difficulty, and experience.',
  },
  {
    icon: 'chart',
    title: 'Feedback reports',
    body: 'Turn each attempt into scores, strengths, weaknesses, and practical suggestions.',
  },
  {
    icon: 'globe',
    title: 'Hindi to English helper',
    body: 'Practice stronger interview English from Hindi prompts and rough answers.',
  },
  {
    icon: 'users',
    title: 'Connect with learners',
    body: 'Find people preparing for similar roles, build useful prep connections, and learn together.',
  },
  {
    icon: 'briefcase',
    title: 'Job referral opportunities',
    body: 'Use your interview profile context to discover and request relevant referral opportunities.',
  },
  {
    icon: 'message',
    title: 'Recorded interview audio',
    body: 'Listen back to your interview recordings and review the questions asked during practice.',
  },
  {
    icon: 'shield',
    title: 'Support and account care',
    body: 'Get help with login, OTP, plans, payments, interviews, reports, and app links.',
  },
];

const plans = [
  {
    title: 'Free demo',
    price: 'Free',
    body: 'A short first practice session with basic feedback.',
    perks: ['1 voice interview', '10 minute technical limit', 'Basic report'],
  },
  {
    title: 'Monthly Pro',
    price: 'Rs. 299 / month',
    body: 'For active preparation before upcoming interviews.',
    perks: ['4 interviews per month', '30 minute technical rounds', 'Advanced reports'],
    featured: true,
  },
  {
    title: '3 Months Plan',
    price: 'Rs. 799 / 3 months',
    body: 'For steady preparation across roles and companies.',
    perks: ['12 interviews total', '30 minute technical rounds', 'Quarterly value'],
  },
];

const pages = {
  privacy: {
    title: 'Privacy Policy',
    intro: 'intervioAi uses account, profile, practice, and support data to provide AI interview preparation features.',
    sections: [
      ['Data we collect', 'We may collect your name, email, mobile number, profile details, role preferences, selected skills, interview answers, audio recordings used for practice, generated reports, subscription status, support messages, and device notification tokens.'],
      ['How we use data', 'We use this information to create personalized interview sessions, generate feedback, improve app reliability, manage subscriptions, send important account notifications, and respond to support requests.'],
      ['AI processing', 'Interview answers and practice prompts may be processed by AI services to generate questions, transcriptions, feedback, improved answers, and reports. Do not share sensitive personal information that is not needed for interview preparation.'],
      ['Permissions', 'Microphone access is used for voice mock interviews. Camera or photo access may be used only for features such as profile pictures or live preview where supported. Notifications are used for reminders, support replies, subscription updates, and important practice nudges.'],
      ['Your choices', 'You can update profile details in the app, disable notifications from device settings, and contact support for account or data requests.'],
      ['Contact', 'For privacy questions or account requests, contact support@intervioai.io.'],
    ],
  },
  terms: {
    title: 'Terms & Conditions',
    intro: 'By using intervioAi, you agree to use the app for learning, preparation, and self-improvement.',
    sections: [
      ['Responsible use', 'Use intervioAi only for lawful interview practice. Do not misuse generated content, disrupt the service, or attempt unauthorized access.'],
      ['AI guidance', 'AI feedback is educational guidance and may not be perfect. Review suggestions with your own judgment before real interviews.'],
      ['Subscriptions', 'Paid plans unlock additional practice limits and features based on the selected plan. Subscription billing, renewal, and cancellation may be handled by the app store used for purchase.'],
      ['Changes', 'Features, pricing, limits, and policies may change as the product improves. Continued use means you accept the latest terms.'],
      ['Support', 'For account, billing, or technical questions, contact support@intervioai.io.'],
    ],
  },
  refund: {
    title: 'Refund Policy',
    intro: 'intervioAi is a technical digital product that provides AI mock interview sessions, voice practice, and generated feedback reports. Purchases are generally non-refundable.',
    sections: [
      ['No refund policy', 'Because intervioAi delivers digital and technical services immediately after access is granted, we do not provide refunds once a plan, subscription, interview credit, or paid feature has been activated or used.'],
      ['Subscriptions and cancellations', 'You may cancel future renewals from the app store or platform where you purchased the plan. Cancellation stops future billing based on that platform policy, but it does not create a refund for an active or already-used billing period.'],
      ['Technical issues', 'If you face a technical issue, contact support@intervioai.io with your registered email, device model, app version, purchase date, and screenshots. We will try to restore access, fix the issue, or help you continue using the service.'],
      ['Exceptional billing cases', 'Duplicate charges, accidental platform billing errors, or unauthorized transactions may be reviewed according to the payment provider or app store rules. Final approval may depend on the platform that processed the payment.'],
      ['AI output disclaimer', 'AI-generated questions, reports, scores, and suggestions are educational guidance and may not be perfect. Dissatisfaction with AI output does not qualify for a refund.'],
    ],
  },
  about: {
    title: 'About Us',
    intro: 'intervioAi helps candidates practice interviews out loud, improve spoken answers, and prepare with clearer feedback.',
    sections: [
      ['Our mission', 'We are building a focused AI interview coach for candidates who want realistic practice before important interviews.'],
      ['What we build', 'intervioAi supports HR, technical, technical deep dive, managerial, final HR, English Helper, feedback reports, and preparation history.'],
      ['Who it is for', 'The product is designed for learners, freshers, working professionals, and job seekers preparing for software, technical, and communication-heavy roles.'],
      ['How we think about AI', 'AI should help candidates practice more often, notice gaps earlier, and walk into interviews with clearer stories. It is a coach, not a guarantee of job selection.'],
    ],
  },
  contact: {
    title: 'Contact Us',
    intro: 'Need help with login, OTP, subscriptions, deep links, interview attempts, reports, or account questions?',
    sections: [
      ['Email', 'Write to support@intervioai.io with your registered email and a clear description of the issue.'],
      ['Phone', 'For urgent support, you can contact +91 8383006681. Availability may vary.'],
      ['What to include', 'Please include your device model, app version, purchase platform, screenshots, and steps to reproduce the issue if you are reporting a bug.'],
      ['Deep links', 'Website links under https://intervioai.io/open/* are configured to open supported app destinations when the app is installed.'],
    ],
  },
  support: {
    title: 'Support',
    intro: 'Need help with login, OTP, payments, subscriptions, interviews, reports, or app links?',
    sections: [
      ['Email support', 'Write to support@intervioai.io with your registered email, device model, app version, and a short description of the issue.'],
      ['Payment help', 'For subscription or invoice issues, include purchase date, plan name, platform, and any transaction ID shown by the app store.'],
      ['Bug reports', 'Share what you tapped, what you expected, what happened, and screenshots if available. Clear steps help us fix issues faster.'],
    ],
  },
};

function Icon({ name }) {
  return (
    <svg className="icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d={iconPaths[name]} />
    </svg>
  );
}

function BrandName({ as: Component = 'span', className = '' }) {
  return (
    <Component className={`brand-name ${className}`}>
      <span>intervio</span><span className="brand-ai">Ai</span>
    </Component>
  );
}

function TextWithBrand({ text }) {
  const parts = text.split('intervioAi');

  return (
    <>
      {parts.map((part, index) => (
        <span key={`${part}-${index}`}>
          {part}
          {index < parts.length - 1 ? <BrandName /> : null}
        </span>
      ))}
    </>
  );
}

function Header() {
  return (
    <header className="site-header">
      <a className="brand" href="/" aria-label="intervioAi home">
        <img src="/app-assets/logo.png" alt="" />
        <BrandName />
      </a>
      <nav aria-label="Primary navigation">
        <a href="/#how">How it works</a>
        <a href="/#features">Features</a>
        <a href="/#pricing">Pricing</a>
        <a href="/about">About</a>
      </nav>
      <div className="header-actions">
        <a className="header-store ios" href={appStoreUrl} aria-label="Download intervioAi on the App Store">
          <img src="/app-assets/apple-logo.png" alt="" />
          <span>App Store</span>
        </a>
        <a className="header-store android" href={playStoreUrl} aria-label="Download intervioAi Android app">
          <Icon name="android" />
          <span>Android App</span>
        </a>
      </div>
    </header>
  );
}

function BrandKicker() {
  return (
    <div className="brand-kicker">
      <img src="/app-assets/logo.png" alt="" />
      <BrandName />
      <span>AI Interview Coach</span>
    </div>
  );
}

function StoreButtons() {
  return (
    <div className="store-actions">
      <a className="store-button primary" href={appStoreUrl}>
        <img src="/app-assets/apple-logo.png" alt="" />
        Download on App Store
        <Icon name="arrow" />
      </a>
      <a className="store-button secondary" href={playStoreUrl}>
        <Icon name="android" />
        Download for Android
        <Icon name="arrow" />
      </a>
    </div>
  );
}

function PhonePreview() {
  return (
    <div className="phone-frame" aria-label="intervioAi mobile app preview">
      <img src="/app-assets/mobile-screenshot.png" alt="intervioAi mobile app home screen" />
    </div>
  );
}

function ProductCloud() {
  const items = [
    ['target', 'Technical Round', 'React Native, DSA, Firebase'],
    ['chart', 'AI Feedback', 'Clarity 86, confidence 92'],
    ['users', 'Learner Network', 'Connect with serious candidates'],
    ['briefcase', 'Job Referrals', 'Apply with prep profile context'],
    ['message', 'Recorded Audio', 'Listen to interview answers again'],
    ['globe', 'English Helper', 'Hindi answer to fluent English'],
  ];

  return (
    <div className="product-cloud" id="product">
      <div className="cloud-column">
        {items.slice(0, 3).map(([icon, title, meta]) => (
          <article key={title}>
            <Icon name={icon} />
            <div>
              <h3>{title}</h3>
              <p>{meta}</p>
            </div>
          </article>
        ))}
      </div>
      <PhonePreview />
      <div className="cloud-column right">
        {items.slice(3).map(([icon, title, meta]) => (
          <article key={title}>
            <Icon name={icon} />
            <div>
              <h3>{title}</h3>
              <p>{meta}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}

function RoundMarquee() {
  return (
    <section className="round-marquee" aria-label="Supported interview practice modes">
      <div>
        {[...rounds, ...rounds, ...rounds].map((round, index) => <span key={`${round}-${index}`}>{round}</span>)}
      </div>
    </section>
  );
}

function SignalStrip() {
  return (
    <section className="signal-strip" aria-label="intervioAi product highlights">
      {signals.map(([value, label]) => (
        <div key={label}>
          <strong>{value}</strong>
          <span>{label}</span>
        </div>
      ))}
    </section>
  );
}

function VoiceExperience() {
  return (
    <section className="section voice-experience">
      <div className="voice-copy">
        <p className="eyebrow">Built for real speaking practice</p>
        <h2>A mock interview should feel alive, not like filling a form.</h2>
        <p>Answer with your voice, replay your recordings, compare feedback, and keep improving until your story sounds clear under pressure.</p>
      </div>
      <div className="voice-stage" aria-hidden="true">
        <div className="voice-orbit">
          <Icon name="mic" />
        </div>
        <div className="wave-lines">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className="feedback-pulse">
          <Icon name="chart" />
          <strong>Clarity improving</strong>
          <span>Use one concrete project example.</span>
        </div>
      </div>
    </section>
  );
}

function LandingPage() {
  return (
    <>
      <section className="hero">
        <BrandKicker />
        <p className="eyebrow">AI voice interview preparation</p>
        <h1>Practice interviews, get feedback, improve faster.</h1>
        <p className="hero-text">
          <BrandName /> turns mock interviews into a focused AI practice space for spoken answers, role-based rounds, English help, and feedback reports.
        </p>
        <StoreButtons />
        <p className="availability">Available on iOS and Android.</p>
        <ProductCloud />
      </section>

      <RoundMarquee />
      <SignalStrip />

      <main>
        <section className="section workflow" id="how">
          <div className="section-heading">
            <h2>Your interview practice, finally working for you.</h2>
            <p>Pick the round, answer out loud, then turn every attempt into a sharper next version.</p>
          </div>
          <div className="workflow-grid">
            {workflow.map(([number, icon, title, body]) => (
              <article key={title}>
                <div className="step-top">
                  <span>{number}</span>
                  <Icon name={icon} />
                </div>
                <h3>{title}</h3>
                <p>{body}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="section features-section" id="features">
          <div className="section-heading center">
            <p className="eyebrow">Now practice what matters</p>
          <h2>Everything supports better spoken answers and better opportunities.</h2>
          </div>
          <div className="feature-grid">
            {features.map(feature => (
              <article className="feature-card" key={feature.title}>
                <Icon name={feature.icon} />
                <h3>{feature.title}</h3>
                <p>{feature.body}</p>
              </article>
            ))}
          </div>
        </section>

        <VoiceExperience />

        <section className="section deep-feature">
          <div>
            <p className="eyebrow">One focused flow</p>
            <h2>From nervous answer to interview-ready story.</h2>
            <p>Train across HR, technical, technical deep dive, managerial, and final HR rounds, then use recordings, feedback, learner connections, and referral opportunities to keep improving.</p>
          </div>
          <div className="report-card">
            <span>Feedback report</span>
            <h3>Strong structure. Add measurable project impact.</h3>
            <div><i style={{ width: '86%' }}></i></div>
          </div>
        </section>

        <section className="section pricing" id="pricing">
          <div className="section-heading center">
            <p className="eyebrow">Plans</p>
            <h2>Start free, upgrade when preparation gets serious.</h2>
          </div>
          <div className="price-grid">
            {plans.map(plan => (
              <article className={`price-card ${plan.featured ? 'featured' : ''}`} key={plan.title}>
                {plan.featured ? <span className="plan-badge">Recommended</span> : null}
                <h3>{plan.title}</h3>
                <p className="price">{plan.price}</p>
                <p>{plan.body}</p>
                <ul>
                  {plan.perks.map(perk => (
                    <li key={perk}>
                      <Icon name="check" />
                      <span>{perk}</span>
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </section>

        <section className="section final-cta">
          <p className="eyebrow">Ready to practice</p>
          <h2>Give your answers a rehearsal before they count.</h2>
          <StoreButtons />
          <p className="availability">Available on iOS and Android.</p>
        </section>
      </main>
    </>
  );
}

function OpenFallbackPage() {
  const quickLinks = [
    ['English Helper', '/open/english-helper'],
    ['Free Demo', '/open/free-demo'],
    ['People', '/open/people'],
    ['Referrals', '/open/referrals'],
    ['Subscription', '/open/subscription'],
  ];

  return (
    <main className="simple-page open-page">
      <div className="simple-copy">
        <p className="eyebrow">Opening <BrandName /></p>
        <h1>Continue in the app.</h1>
        <p>If <BrandName /> is installed, this link should open the right screen automatically. If it does not, open the app and continue from Home.</p>
        <StoreButtons />
      </div>
      <div className="deep-link-list">
        {quickLinks.map(([label, href]) => (
          <a href={href} key={href}>
            <Icon name="arrow" />
            <span>{label}</span>
          </a>
        ))}
      </div>
    </main>
  );
}

function InfoPage({ page }) {
  return (
    <main className="simple-page">
      <div className="simple-copy">
        <p className="eyebrow"><BrandName /></p>
        <h1>{page.title}</h1>
        <p><TextWithBrand text={page.intro} /></p>
      </div>
      <div className="policy-list">
        {page.sections.map(([title, body]) => (
          <section className="policy-section" key={title}>
            <h2>{title}</h2>
            <p><TextWithBrand text={body} /></p>
          </section>
        ))}
      </div>
    </main>
  );
}

function App() {
  const path = window.location.pathname.replace(/^\/+/, '').split('/')[0] || 'home';

  return (
    <div className="App">
      <Header />
      {window.location.pathname.startsWith('/open') ? (
        <OpenFallbackPage />
      ) : pages[path] ? (
        <InfoPage page={pages[path]} />
      ) : (
        <LandingPage />
      )}
      <footer className="footer">
        <div className="footer-brand">
          <BrandName />
          <p>AI mock interview platform for spoken practice and feedback reports.</p>
        </div>
        <div className="footer-links">
          <a href="/about">About</a>
          <a href="/contact">Contact</a>
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
          <a href="/refund">Refund</a>
          <a href="/support">Support</a>
        </div>
        <div className="footer-meta">
          <span>Built by Engineer Codewala.</span>
          <span>© 2026 intervioAi. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
}

export default App;
